document.addEventListener("DOMContentLoaded", function() {
  const productDesc = document.querySelector(".product__description.product__block.product__block--medium");

  if (productDesc) {
    const listItems = productDesc.querySelectorAll("li");
    listItems.forEach(li => {
      li.textContent = li.textContent.replace(/\?/g, "— ");
    });
  }

  // Modal open & close logic
  const images = document.querySelectorAll(".gallery-container img");
  const openBtn = document.querySelector(".gallery-show-more");
  const modal = document.getElementById("galleryModal");
  const modalContent = document.getElementById("galleryModalContent");
  const closeBtn = document.querySelector(".gallery-close");

  if (openBtn) {
    // If no images found, hide the show more button
    if (!images || images.length === 0) {
      openBtn.style.display = "none";
    } else if (modal && modalContent) {
      openBtn.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Populate modal images if empty
        if (!modalContent.hasChildNodes() || modalContent.children.length === 0) {
          images.forEach(img => {
            const clone = img.cloneNode(true);
            clone.style.width = "100%";
            clone.style.height = "auto";
            clone.style.display = "block";
            modalContent.appendChild(clone);
          });
        }

        modal.classList.add("active");
        document.body.classList.add("modal-open");
      });

      if (closeBtn) {
        closeBtn.addEventListener("click", function(e) {
          e.preventDefault();
          modal.classList.remove("active");
          document.body.classList.remove("modal-open");
        });
      }
    }
  }
});